export const APIRoutes = {
  apiGetDotPhrasesList: "/patient-centric-app-v2/dot-phrases/of_type",
  // mix panel error store
  apiMixPanelErrorStore: `/patient-centric-app-v2/mixpanel/log-error`,

  // User Signup:
  apiSignup: `/patient-centric-app-v2/admin/v3/users/complete-signup`,

  // User Agreement
  userAgreement: `/user-agreement/userAgreement`,
  getPatientsList: `/patient-centric-app-v2/clinic/patient_list`,

  // Clinics
  apiMyClinic: `/patient-centric-app-v2/clinic/my-clinic`,
  apiGetClinicFloor: `/patient-centric-app-v2/clinic/{clinic_id}/user-pref/floors`,
  apiSetClinicFloor: `/patient-centric-app-v2/clinic/{clinic_id}/user-pref/floors`,
  apiResidentList: `/patient-centric-app-v2/clinic/patient_list`,
  apiClinicDailyReportClinic: `/patient-centric-app-v2/v2/clinic_report`,

  // Alert
  apiGetAlertListNew: `/patient-centric-app-v2/clinic/{clinic_id}/v2/clinical-alerts`,
  apiGetAlertDetail: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{resident_id}/v3/clinical-alerts/{alert_id}`,
  apiAddAlertComment: `/patient-centric-app-v2/clinic/{clinic_id}/acknowledge/alert/{alert_id}`,
  apiGetPSNAck: `/patient-centric-app-v2/clinic/{clinic_id}/PSN/alert/{alert_id}`,
  apiAddPSNAck: `/patient-centric-app-v2/clinic/{clinic_id}/psn_v2/alert/{alert_id}/ack`,
  apiGetCombinedAlertList: `/patient-centric-app-v2/clinic/{clinic_id}/patients/escalated-flagged/v2`,
  apiGetFlagList: `/patient-centric-app-v2/clinic/{clinic_id}/v2/patients/flagged`,
  apiAddAlertAck: `/patient-centric-app-v2/clinic/{clinic_id}/ack/alerts/v2`,
  apiPatientAlert: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/escalated-flagged/v2`,
  apiGetFlagAlertClinical: `/patient-centric-app-v2/clinic/{clinic_id}/clinical-listing`,
  apiHideFlag: `/patient-centric-app-v2/clinic/{clinic_id}/psn_v2/alert/{flagged_id}/hide`,
  apiGetInboxFlagsByReviewStatus: `/patient-centric-app-v2/clinic/{clinic_id}/inbox/flags`,
  // Patient-centric flags API (coworker's new endpoint)
  apiGetPatientFlags: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/flags`,

  // Billing / Payers
  apiGetBillingPayers: `/patient-centric-app-v2/billing/payers`,
  apiCreateBillingPayer: `/patient-centric-app-v2/billing/payers`,
  apiUpdateBillingPayer: `/patient-centric-app-v2/billing/payers/{id}`,
  apiDeleteBillingPayer: `/patient-centric-app-v2/billing/payers/{id}`,

  // Billing / Providers
  apiGetBillingProviders: `/patient-centric-app-v2/billing/providers`,
  apiCreateBillingProvider: `/patient-centric-app-v2/billing/providers`,
  apiUpdateBillingProvider: `/patient-centric-app-v2/billing/providers/{id}`,
  apiDeleteBillingProvider: `/patient-centric-app-v2/billing/providers/{id}`,

  // Billing / Entity
  apiGetBillingEntity: `/patient-centric-app-v2/billing/entities`,
  apiCreateBillingEntity: `/patient-centric-app-v2/billing/entity`,
  apiUpdateBillingEntity: `/patient-centric-app-v2/billing/entity/{id}`,
  apiDeleteBillingEntity: `/patient-centric-app-v2/billing/entity/{id}`,

  // Billing / Roster
  apiGetBillingRosters: `/patient-centric-app-v2/billing/rosters`,
  apiCreateBillingRoster: `/patient-centric-app-v2/billing/rosters`,
  apiUpdateBillingRoster: `/patient-centric-app-v2/billing/rosters/{id}`,
  apiDeleteBillingRoster: `/patient-centric-app-v2/billing/rosters/{id}`,

  //Dashboard
  apiGetDashboardList: `/patient-centric-app-v2/clinic/{clinic_id}/cip/v2/psn-alerts`,
  apiGetPsnAlertGraphDataList: `/patient-centric-app-v2/clinic/{clinic_id}/patients/daily_rr_graph`,
  apiGetPatientListDashboard: `/patient-centric-app-v2/clinic/{clinic_id}/v2/recent/admissions`,
  apiGetReAdmitRadatMostCritical: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/v2/readmit_radar/most-critical`,

  //s3
  apiGetFileFromS3: "/patient-centric-app-v2/aws/document",

  //support
  apiReportAProblem: `/patient-centric-app-v2/clinic/{clinic_id}/report-problem/cip/customer-support`,
  apiSubmitFeedback: `/patient-centric-app-v2/feedback/cip`,
  apiSubmitRating: `/patient-centric-app-v2/delighted/rating`,

  //push Notifications
  apiStoreToken: `/patient-centric-app-v2/v3/token`,
  apiGetNotificationSettings: `/patient-centric-app-v2/user/v4`,
  apiPutNotificationSettings: `/patient-centric-app-v2/user/preference/notification/v4`,

  //SMS
  apiSendOTP: `/patient-centric-app-v2/twilio/send-otp`,
  apiVerifyOTP: `/patient-centric-app-v2/verify-otp`,
  apiSavePhoneNumber: `/patient-centric-app-v2/user_info/user_phone_number`,

  //report
  apiGetClinicalReport: `/patient-centric-app-v2/clinic/{clinic_id}/daily_reports`,
  apiGetDailyReport: `/patient-centric-app-v2/clinic/{clinic_id}/daily_reports/{daily_report_id}`,
  apiAddReadDailyReport: `/patient-centric-app-v2/clinic/{clinic_id}/daily_reports/{daily_report_id}/read`,
  // report - AI risk report
  apiGetRiskReport: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/v4/gpt/{date}`,
  apiGetReadmitRadar: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/readmit_radar/v4`,
  apiGetRiskReportClinicPreference: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/gpt/clinic_preference`,
  apiGetRiskReportList: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/list/v2`,
  apiAckRiskReport: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/ack/idt_report/{idt_report_id}`,

  // report - AI risk report public routes
  apiGetRiskReportPublicRoute: `/patient-centric-app-v2/idt_reports/link/summaries`,
  apiGetReadmitRadarPublicRoute: `/patient-centric-app-v2/idt_reports/link/readmit_radar`,
  apiGetRiskReportClinicPreferencePublicRoute: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/gpt/clinic_preference`,
  apiGetRiskReportListPublicRoute: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/list-`,
  apiAckRiskReportPublicRoute: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/ack/idt_report/{idt_report_id}-`,

  //patient
  apiGetPatientList: `/patient-centric-app-v2/clinic/{clinic_id}/v2/patients`,
  apiGetPatientEventList: `/patient-centric-app-v2/clinic/{clinic_id}/resident/{resident_id}/v5/events`,
  apiGetPatientSummary: `/patient-centric-app-v2/clinic/{clinic_id}/resident/{resident_id}/v4/patient-chart-summary`,
  apiGetPatientCircadiaVital: `/patient-centric-app-v2/clinic/{clinic_id}/resident/{resident_id}/last-circadia-vitals`,
  apiGetPatientPCCVital: `/patient-centric-app-v2/clinic/{clinic_id}/resident/{resident_id}/last-pcc-vitals`,
  apiGetPatientRespRate: `/patient-centric-app-v2/clinic/{clinic_id}/patients/rr-metrics-psn`,
  apiGetPatientVitalGraph: `/patient-centric-app-v2/clinic/{clinic_id}/resident/{resident_id}/pcc-vitals-history`,
  apiGetPatientRRGraph: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{resident_id}/rr_graph`,
  apiGetPatientNotes: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{resident_id}/cip/combined-circadia-notes`,
  apiGetPatientPCCNotes: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{resident_id}/pcc-notes`,
  apiAddPatientNote: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{resident_id}/v2/notes`,
  // search
  apiGetSearch: `/patient-centric-app-v2/clinic/{clinic_id}/v3/patients`,

  apiGetAllPatientList: `/patient-centric-app-v2/clinic/{clinic_id}/resident/listing`,

  // Get all patients list (room assigned and not assigned) - V2 API
  apiGetAllPatientListV2: `/patient-centric-app-v2/clinic/{clinic_id}/v2/resident/listing`,

  // device
  apiOfflineDevice: "/patient-centric-app-v2/clinic/{clinic_id}/device/offline",
  // apiAllDevice: "/patient-centric-app/clinic/device/status",
  apiAllDevice: "/patient-centric-app-v2/clinic/{clinic_id}/devices",

  //insights
  apiGetTOCAllowedMonths:
    "/patient-centric-app-v2/clinic/{clinic_id}/TOC/allowed_months",
  apiGetTOPAllowedMonths:
    "/patient-centric-app-v2/clinic/{clinic_id}/TOP/allowed_months",
  apiGetDischargeAllowedMonths:
    "/patient-centric-app-v2/clinic/{clinic_id}/discharge_insights/allowed_months",
  apiGetTOC: "/patient-centric-app-v2/clinic/{clinic_id}/v2/TOC",
  apiGetTOP: "/patient-centric-app-v2/clinic/{clinic_id}/TOP",
  apiGetDischarge:
    "/patient-centric-app-v2/clinic/{clinic_id}/v2/discharge_insights",
  apiGetTOCRootCause:
    "/patient-centric-app-v2/clinic/{clinic_id}/transfer_out/{TO_EVENT_ID}/RCA",

  // Outcomes
  apiGetOutcomesFacilities:
    "/patient-centric-app-v2/clinic/{clinic_id}/outcomes/facilities",
  apiGetOutcomesAvailablePeriods:
    "/patient-centric-app-v2/clinic/{clinic_id}/outcomes/available_periods",
  apiGetOutcomesTimeSeries:
    "/patient-centric-app-v2/clinic/{clinic_id}/outcomes/time_series",
  apiGetOutcomesFilterOptions:
    "/patient-centric-app-v2/clinic/{clinic_id}/outcomes/filter_options",

  //watchlist
  apiGetWatchlist: `/patient-centric-app-v2/clinic/{clinic_id}/my/watchlist/v2/patients/details`,
  apiPutWatchlist: `/patient-centric-app-v2/clinic/{clinic_id}/my/watchlist/change`,

  //consent
  apiGetConsentList: `/patient-centric-app-v2/clinic/{clinic_id}/consent-email-ledger/consent_listing`,
  apiGetConsentDischargeList: `/patient-centric-app-v2/clinic/{clinic_id}/consent-email-ledger/v2/discharge/all_resident`,
  apiPostConsentChange: `/patient-centric-app-v2/clinic/{clinic_id}/consent-email-ledger/v4/change`,

  //CDL Endpoints
  apiPatientGraphData: `/circadia-vitals/patient_processed/{patient_id}/`,
  apiPatientGraphDataV2: `/v2/circadia-vitals/patient_processed/`,
  // Intercom
  apiGetUserHmac: "/patient-centric-app-v2/user/intercom/token",

  // Circadia IQ
  apiGenerateCircadiaIQ:
    "/patient-centric-app-v2/circadia_iq/v4/{clinic_id}/patient/{patient_id}",
  apiGetCircadiaIQ:
    "/patient-centric-app-v2/circadia_iq/v4/{clinic_id}/patient/{patient_id}/db",

  // bed exits
  apiAddBedExits: `/patient-centric-app-v2/user/bed-exit/settings/v2`,
  apiAddBedExitsV3: `/patient-centric-app-v2/clinic/{clinic_id}/user/bed-exit/settings/v3`,
  apiUpdateBedExitsTime: `/patient-centric-app-v2/user/bed-exit/settings/time`,
  apiUpdateBedExits: `/patient-centric-app-v2/user/bed-exit/settings/toggle/v3`,
  apiGetBedExitSettingsByUserPref: `/patient-centric-app-v2/clinic/{clinic_id}/user/bed-exits/v2`,
  apiGetPatientNotificationSettings: `/patient-centric-app-v2/clinic/{clinic_id}/resident/{resident_id}/bed-exits/v2`,
  apiGetDiagnoses:
    "/patient-centric-app-v2/clinic/{clinic_id}/resident/{resident_id}/patient-diagnosis",
  apiUpdatePatientNotificationSettings: `/patient-centric-app-v2/user/bed-exit/settings/v2`,
  apiUpdatePatientNotificationSettingsV2: `/patient-centric-app-v2/user/bed-exit/settings/v3`,
  apiUpdateCombineBedExits: `/patient-centric-app-v2/user/bed-exit/settings/combine`,

  // Bed Exit Event List
  apiGetBedExitEventList:
    "/patient-centric-app-v2/clinic/{clinic_id}/v2/bed-exit-events",

  apiGetBedExitFacilityReport:
    "/patient-centric-app-v2/clinic/{clinic_id}/bed-exit-comparison",

  // Users
  apiUserBetaFeature: `/patient-centric-app-v2/user/beta-feature`,

  // Tracking
  apiTracking: `/`,

  // Summary
  apiGetSummary: `/patient-centric-app-v2/clinic/{clinic_id}/v4/alerts/summary`,

  // IPV
  apiGetIPVNotesList: `/patient-centric-app-v2/clinic/{clinic_id}/v2/ipv_notes?status={status}`,
  apiAddIPVNotesAck: `/patient-centric-app-v2/clinic/{clinic_id}/acknowledge/ipv_note/{note_id}`,

  // Device Issues
  apiPostDeviceIssue: `/patient-centric-app-v2/clinic/{clinic_id}/device-issues`,

  // Home Health apis
  apiGetSinglePatientInfo: "/home_health/patient/{patient_id}",
  apiGetPatientGraphData: "/home_health/patient/{patient_id}/readings",
  apiGetSelectedFacilityPatientList: "/home_health/facility/{clinic_id}/",
  // User Info
  apiUpdateUserInfo: `/patient-centric-app-v2/user/v2/name`,

  // Sales
  apiAddSalesAck: `/patient-centric-app-v2/clinic/{clinic_id}/demo-request`,

  // RT Blogger
  apiPostParseRTAR: `/pcc_blogger/clinic/{clinic_id}/parse_pdf`,
  apiPostRTARBilling: `/pcc_blogger/clinic/{clinic_id}/patient/{patient_id}/generate_billing/{month}/{year}`,
  apiGetBillingSettings: `/pcc_blogger/rt-billing/clinic/{clinic_id}/settings`,
  apiUpdateBillingSettings: `/pcc_blogger/rt-billing/clinic/{clinic_id}/settings`,
  apiGetServices: `/pcc_blogger/rt-billing/services`,
  apiUpdateServices: `/pcc_blogger/rt-billing/services`,
  apiGetAudit: `/pcc_blogger/rt-billing/clinic/{clinic_id}/audit_settings`,
  apiUpdateAudit: `/pcc_blogger/rt-billing/clinic/{clinic_id}/audit_settings`,
  apiGetCPTTypes: `/pcc_blogger/rt-billing/cpt-types`,
  apiPutBillingServiceStatus: `/pcc_blogger/rt-billing/clinic/{clinic_id}/patient/{patient_id}/billing-service-logs`,
  apiGetOverviewPatients: `/pcc_blogger/rt-billing/clinic/{clinic_id}/billing-service-logs/{month}/{year}`,
  apiGetBillingCycle: `/pcc_blogger/rt-billing/clinic/{clinic_id}/billing-cycles`,
  apiGetBillingCycleForPatient: `/pcc_blogger/rt-billing/clinic/{clinic_id}/patient/{patient_id}/billing-service-logs/{month}/{year}`,
  apiDeleteBillingCycle: `/pcc_blogger/rt-billing/clinic/{clinic_id}/billing-cycles/{month}/{year}`,
  apiPutBillingCycleStatusForPatient: `/pcc_blogger/rt-billing/clinic/{clinic_id}/patient/{patient_id}/billing-cycles/{month}/{year}`,
  apiDeleteBillingCycleForPatient: `/pcc_blogger/rt-billing/clinic/{clinic_id}/patient/{patient_id}/billing-cycles/{month}/{year}`,
  apiPostBillingFiles: `/pcc_blogger/rt-billing/clinic/{clinic_id}/billing-files`,
  apiPostFixError: `/pcc_blogger/rt-billing/clinic/{clinic_id}/patient/{patient_id}/fix-errors`,

  // VitalSync
  apiExtractVitals: `/patient-centric-app-v2/clinic/{clinic_id}/extract-vitals`,
  apiSubmitVitalsToPCC: `/patient-centric-app-v2/clinic/{clinic_id}/pcc/submit`,
  apiGetPCCSubmissionStatistics: `/patient-centric-app-v2/clinic/{clinic_id}/pcc/submission/statistics`,
  apiGetPCCQueueList: `/patient-centric-app-v2/clinic/{clinic_id}/pcc/queue/list`,
  apiGetPCCQueueStatus: `/patient-centric-app-v2/clinic/{clinic_id}/pcc/queue/status`,
  apiGetPCCSubmissionHistory: `/patient-centric-app-v2/clinic/{clinic_id}/pcc/submission/history`,

  // Enrolment
  apiGetEnrolledPatients: `/pcc_blogger/clinic/{clinic_id}/patients`,
  apiGetPreviouslyEnrolledPatients: `/rtx/patients/status_base_list/{clinic_id}`,
  apiPutEnrollPatient: `/pcc_blogger/enrolment/new/{admission_id}`,
  apiPutExtendEnrollPatient: `/pcc_blogger/enrolment/update/{rtx_enrolment_id}`,

  // Billing Reports
  apiGetBillingReports: `/pcc_blogger/rt-billing/clinic/{clinic_id}/reports`,
  apiUpdateBillingReportCollectedAmount: `/pcc_blogger/rt-billing/clinic/{clinic_id}/update_collections/{month}/{year}`,

  // PSN v2 Review
  apiPutPSNAcknowledge: `/patient-centric-app-v2/clinic/{clinic_id}/psn_v2/shift_report/{notification_uuid}/ack`,

  apiPostAppPerformanceSurvey: `/patient-centric-app-v2/delighted/nps`,
  apiGetFacilities: "/patient-centric-app-v2/clinics",
  apiGetAllFacilities: "/patient-centric-app-v2/admin/clinics",

  apiAssignFacility: "/patient-centric-app-v2/users/{userId}/clinics",

  // HealthScribe APIs - V1 (Legacy - kept for backward compatibility)
  healthScribeTranscriptionList: `/patient-centric-app-v2/healthscribe/transcription/list`,
  healthScribeGetSession: `/patient-centric-app-v2/healthscribe/recording/clinic/{clinic_id}/session/{session_id}`,
  healthScribeListSessions: `/patient-centric-app-v2/healthscribe/recording/clinic/{clinic_id}/sessions`,
  healthScribeS3UploadInit: `/patient-centric-app-v2/healthscribe/s3/upload/init`,
  healthScribeS3UploadPart: `/patient-centric-app-v2/healthscribe/s3/upload/part`,
  healthScribeS3UploadComplete: `/patient-centric-app-v2/healthscribe/s3/upload/complete`,
  healthScribeS3UploadCompleteAudio: `/patient-centric-app-v2/healthscribe/s3/upload/audio`,
  healthScribeS3UploadAbort: `/patient-centric-app-v2/healthscribe/s3/clinic/{clinic_id}/upload/{session_id}/{upload_id}`,
  healthScribeS3UploadStatus: `/patient-centric-app-v2/healthscribe/s3/clinic/{clinic_id}/upload/status/{session_id}/{upload_id}`,

  // HealthScribe APIs - V2 (Multi-Segment with Pause/Resume)
  healthScribeV2StartRecording: `/patient-centric-app-v2/healthscribe/v2/recording/start`,
  healthScribeV2StopRecording: `/patient-centric-app-v2/healthscribe/v2/recording/stop`,
  healthScribeV2TranscriptionBatchSave: `/patient-centric-app-v2/healthscribe/v2/transcription/batch-save`,
  healthScribeV2NarrativeGenerate: `/patient-centric-app-v2/healthscribe/v2/narrative/generate`,
  healthScribeV2SessionComplete: `/patient-centric-app-v2/healthscribe/v2/session/complete`,
  healthScribeV2GetSession: `/patient-centric-app-v2/healthscribe/v2/session/{session_id}`,
  healthScribeV2ListSegments: `/patient-centric-app-v2/healthscribe/v2/session/{session_id}/segments`,
  healthScribeV2ListSessions: `/patient-centric-app-v2/healthscribe/v2/clinic/{clinic_id}/sessions`,

  // HealthScribe APIs - Heidi STT Integration (replaces WebSocket streaming)
  healthScribeHeidiTranscribe: `/patient-centric-app-v2/healthscribe/heidi/transcribe/{session_id}`,
  healthScribeHeidiTranscript: `/patient-centric-app-v2/healthscribe/heidi/transcript/{session_id}`,
  healthScribeHeidiRecover: `/patient-centric-app-v2/healthscribe/heidi/recover`,
  healthScribeHeidiAppendTranscript: `/patient-centric-app-v2/healthscribe/heidi/append-transcript/{session_id}`,

  // Initial Patient Visit (IPV)
  apiGetIPVNotesByClinicID: `/patient-centric-app-v2/clinic/{clinic_id}/ipv_notes?status={status}`,
  apiGetIPVNotesByClinicIDv3: `/patient-centric-app-v2/clinic/{clinic_id}/v3/ipv_notes`,
  apiPostIPVNote: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/ipv_notes`,
  apiPostPatientExtraInfo: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/extra-info`,
  apiGetIPVNotesByPatientID: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/ipv_notes`,
  apiDeleteIPVNote: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/ipv_notes/{ipv_note_id}`,
  apiGetPatientsForNavigator: `/patient-centric-app-v2/clinic/{clinic_id}/navigator/patients`,
  apiGetPatientVisitNotes: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/visit-notes`,

  apiPutIPVNote: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/ipv_notes/{ipv_note_id}`,
  apiDeleteIPVDraftAndSession: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/recording-draft`,

  // HPI Template APIs
  apiGetHPITemplates: `/patient-centric-app-v2/HPI/template/list`,
  apiCreateHPITemplate: `/patient-centric-app-v2/HPI/template/create`,
  apiGetSingleHPITemplate: `/patient-centric-app-v2/HPI/template/{template_id}`,
  apiUpdateHPITemplate: `/patient-centric-app-v2/HPI/template/update`,
  apiDeleteHPITemplate: `/patient-centric-app-v2/HPI/template/delete/{template_id}`,

  // Unified Visit Notes API (CREATE and UPDATE only - draft loading still uses legacy IPV API)
  apiCreateVisitNote: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/visit-notes`,
  apiUpdateVisitNote: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/visit-notes/{note_id}`,

  apiStorePreChartNote: `/patient-centric-app-v2/clinic/{clinic_id}/pre-chart-note`,
} as const;

export type IAPIRoutes = typeof APIRoutes;
